<template>
  <div
    :class="[
      'organism neighborhoods-by-collection-map',
      'container-' + organism.containerWidth,
      organism.removeMargin,
    ]"
  >
    <OrganismsHeadingTransition class="" :organism="organism" />
    <div class="relative pointer-events-none">
      <div
        id="map-wrap"
        class="block absolute -mt-[25px] lg:mt-0 lg:absolute lg:-top-7 lg:left-0 h-[300px] lg:h-full w-full isolate -z-10"
      >
        <div id="map" class="w-full h-full pointer-events-auto"></div>
      </div>
      <div
        class="flex items-start min-h-[820px] flex-row-reverse w-full mx-auto pointer-events-none max-w-screen-xl pt-[275px] lg:pt-0"
      >
        <div
          class="w-full lg:w-2/5 lg:max-w-[488px] shadow lg:my-0 xl:my-12 lg:mr-0 xl:mr-8 bg-white pointer-events-auto pb-20 lg:pb-0"
        >
          <div class="px-8 py-10 text-center text-white tabs-container">
            <h2 class="font-archer font-bold text-[32px] drop-shadow-text">
              Our Neighborhoods
            </h2>
          </div>
          <div
            class="px-8 sm:px-6 pt-4 tabs-component lg:max-h-[clamp(600px,_75vh,_1200px)] sm:overflow-y-scroll overflow-hidden"
          >
            <div v-for="group in neighborhoodGroups">
              <MoleculesOverviewItemGroup
                v-if="group?.items?.length"
                :group="group"
                tab-id="neighborhoods"
              />
            </div>

            <p
              v-if="overview.filterResultsEmpty"
              class="pt-8 pb-12 text-gray-500"
            >
              There were 0 results for this collection at this time.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.neighborhoods-by-collection-map {
  .tabs-container {
    background-image: linear-gradient(113deg, #367ea0 1%, #4dadce 96%);
  }
  .overview-group-heading {
    h3 {
      @apply whitespace-normal sm:whitespace-nowrap text-center min-w-[75%] sm:min-w-fit;
    }
  }
}

.selected-item {
  @apply outline outline-4 outline-bc-blue;
}
</style>

<script setup>
import { storeToRefs } from "pinia";
const overview = useOverview();
overview.fetchOverview();
const { collectionFilter, mapInfo } = storeToRefs(overview);

const props = defineProps({
  organism: Object,
});

const hideGroupHeadingIfEmpty = () => {
  const groups = document.querySelectorAll(
    ".neighborhoods-by-collection-map .overview-item-group",
  );

  groups.forEach((group) => {
    const items = group.querySelectorAll("article.item");
    let visibleItemCount = 0;

    items.forEach((item) => {
      const itemIsVisible = item.parentNode.style.display !== "none";

      if (itemIsVisible) {
        visibleItemCount++;
      }
    });

    group.style.display = visibleItemCount ? "block" : "none";
  });
};

collectionFilter.value = props.organism.collection;

const filterByCollection = () => {
  const items = document.querySelectorAll(
    ".neighborhoods-by-collection-map .overview-item-group article.item",
  );

  let itemCounter = 0;
  items.forEach((item) => {
    item.parentNode.style.display = "none";
    if (
      kebabCase(item?.dataset?.collections).includes(
        kebabCase(props?.organism?.collection),
      )
    ) {
      item.parentNode.style.display = "block";
      itemCounter++;
    }
  });
  overview.filterResultsEmpty = itemCounter ? false : true;

  hideGroupHeadingIfEmpty();
};

const areasUnique = computed(() => {
  const areas = overview?.neighborhoods?.nodes?.map(
    (node) => node?.neighborhood.neighborhoodArea,
  );
  // Return unique multidimensional array
  return (
    areas
      ?.map(JSON.stringify)
      .filter((e, i, a) => i === a.indexOf(e))
      .map(JSON.parse) ?? []
  );
});

const neighborhoodGroups = computed(() => {
  return areasUnique?.value?.map((area) => {
    return Array.isArray(area)
      ? {
          areaName: area[0],
          areaTitle: area[1],
          items: overview?.neighborhoods?.nodes?.filter(function (node) {
            return this[0] === node.neighborhood.neighborhoodArea[0];
          }, area),
          plans: overview?.plans?.nodes ?? [],
        }
      : {};
  });
});

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }
  loadOverviewMap();
  updateOverviewMap(mapInfo, filterByCollection);
});

watch(mapInfo, () => {
  updateOverviewMap(mapInfo, filterByCollection);
});
</script>
